import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageSection, InfoPageImage, InfoPageHeaderTitle } from 'components';
import { Helmet } from 'react-helmet';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalPaymentOptionsIT extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Opzioni di pagamento';
		const siteDescription = 'Opzioni di pagamento descrizione';
		const siteKeywords = 'Opzioni di pagamento parole chiave';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/paymentoptions/it';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<InfoPageHeaderTitle>Opzioni di pagamento</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<InfoPageSection>
						<p>
							Può utilizzare uno qualsiasi dei tipi di pagamento elencati di seguito per pagare il vostro ordine, ad
							eccezione di Apple Pay*.
						</p>
						<InfoPageImage imageUrl={require('../PaymentOptions/images/PaymentOptions.png')} />
						<p>Noi prendiamo molto seriamente la vostra sicurezza, quindi i vostri dati sono al sicuro con noi.</p>
						<p>
							Prendiamo molto seriamente anche le frodi, quindi tutti i titolari di carte di credito e di debito sono
							soggetti a convalida e autorizzazione sia da parte nostra (tramite Stripe) che dell'emittente della carta.
						</p>
						<p>
							*Nota: Apple Pay è disponibile solo come metodo di pagamento per certi paesi selezionati, quando si
							utilizza un dispositivo supportato. Se Apple Pay è disponibile per il vostro paese, vedrai questa opzione
							di pagamento alla cassa.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalPaymentOptionsIT };
